import useLogger from '@/hooks/useLogger';
import { LoggerParams } from '@/types/log';
import { ReactNode, useEffect, useRef } from 'react';
import styled from 'styled-components';

let listViewStartedAt = new Date().getTime();

interface Props {
  enabled?: boolean;
  children: ReactNode;
  params: LoggerParams;
}

const ImpressionLogger = (props: Props) => {
  const { enabled = true } = props;
  const logger = useLogger();
  const shouldLog = useRef<boolean>(true);
  const itemRef = useRef<HTMLDivElement>(null);

  const setLoggingEnabled = () => {
    shouldLog.current = true;
  };

  const setLoggingDisabled = () => {
    shouldLog.current = false;
  };

  const logging = () => {
    logger.log({
      eventName: props.params.eventName,
      payload: {
        ...props.params.payload,
        listViewStartedAt,
      },
    });
  };

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        if (!shouldLog.current) {
          return;
        }

        setLoggingDisabled();
        logging();
      });
    });

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, [enabled]);

  useEffect(() => {
    setLoggingEnabled();
    listViewStartedAt = new Date().getTime();

    return () => {
      setLoggingDisabled();
    };
  }, []);

  return <Wrapper ref={itemRef}>{props.children}</Wrapper>;
};

export default ImpressionLogger;

const Wrapper = styled.div``;
